import { useState } from "react";
import { setSession, clearSession, getUserIds, getUser, clearApplicationDraft, clearPostApplicationDraft } from "../api/session";
import { logout, extractSession } from "../api/authApi";

// Login/logout + the current user profile shown in the dashboard header.
export default function useSession({ navigate }) {
  const [user, setUser] = useState(getUser);

  const handleLoginSuccess = (data) => {
    const { token, user: loggedInUser } = extractSession(data);
    setSession(token, loggedInUser);
    setUser(loggedInUser);
    navigate("/dashboard");
  };

  const handleLogout = async () => {
    const { user_id: userId } = getUserIds();
    try {
      if (userId) await logout(userId);
    } catch {
      // still log out locally even if the API call fails
    }
    clearSession();
    clearApplicationDraft();
    clearPostApplicationDraft();
    setUser(null);
    navigate("/login");
  };

  return { user, handleLoginSuccess, handleLogout };
}
